<div class="menu-box">
  <mat-list class="dashboard-menu">

    <!-- Ligne 1 : suivi des alertes, commandes et applications -->
    <div class="menu-row">
      <a
        class="box"
        routerLink="/core/dashboard/alerts"
        [style.background-color]="theme.getColor('Main Dark')"
      >
        <div class="box-icon">
          <mat-icon>notifications</mat-icon>
        </div>

        <div class="box-label">
          Suivi des Alertes
        </div>
      </a>

      <a
        class="box"
        routerLink="/core/dashboard/orders"
        [style.background-color]="theme.getColor('Main Dark')"
      >
        <div class="box-icon">
          <mat-icon>dvr</mat-icon>
        </div>

        <div class="box-label">
          Suivi de Commandes
        </div>
      </a>

      <a
        class="box"
        routerLink="/core/dashboard/apps"
        [style.background-color]="theme.getColor('Main Dark')"
      >
        <div class="box-icon">
          <mat-icon>train</mat-icon>
        </div>

        <div class="box-label">
          Suivi d'Applications
        </div>
      </a>
    </div>

    <mat-divider></mat-divider>

    <!-- Ligne 2 : suivi des nettings et indicateurs de service -->
    <div class="menu-row">
      <a
        class="box"
        routerLink="/core/facturation/facturation-vue_netting"
        [style.background-color]="theme.getColor('Main Dark')"
        [class.box-hidden]="isSuiviNettingsHidden()"
      >
        <div class="box-icon">
          <mat-icon>receipt</mat-icon>
        </div>

        <div class="box-label">
          Suivi des Nettings
        </div>
      </a>

      <a
        class="box"
        routerLink="/core/dashboard/powerbi"
        [style.background-color]="theme.getColor('Main Dark')"
        [class.box-hidden]="
          config.getConfiguration().DashboardPowerBi === 'false'
        "
      >
        <div class="box-icon">
          <mat-icon>analytics</mat-icon>
        </div>

        <div class="box-label">
          Indicateurs de service
        </div>
      </a>
    </div>

    <mat-divider></mat-divider>

    <!-- Ligne 3 : FEB, devis, validation et audit -->
    <div class="menu-row">
      <a
        class="box"
        routerLink="/core/fiche-expression-besoin"
        [style.background-color]="theme.getColor('Main Dark')"
        [class.box-hidden]="isFebHidden()"
      >
        <div class="box-icon">
          <mat-icon>description</mat-icon>
        </div>

        <div class="box-label">
          Fiches Expression de Besoin
        </div>
      </a>

      <a
        class="box"
        routerLink="/core/devis"
        [style.background-color]="theme.getColor('Main Dark')"
        [class.box-hidden]="isDevisHidden()"
      >
        <div class="box-icon">
          <mat-icon>request_quote</mat-icon>
        </div>

        <div class="box-label">
          Gestion des Devis
        </div>
      </a>

      <a
        class="box"
        routerLink="/core/devis-validation"
        [style.background-color]="theme.getColor('Main Dark')"
        [class.box-hidden]="isDevisValidationHidden()" 
        style="display: none;"
      >
        <div class="box-icon">
          <mat-icon>fact_check</mat-icon>
        </div>

        <div class="box-label">
          Validation des Devis
        </div>
      </a>

      <a
        class="box"
        routerLink="/core/audit"
        [style.background-color]="theme.getColor('Main Dark')"
        [class.box-hidden]="isAuditHidden()"
      >
        <div class="box-icon">
          <mat-icon>history</mat-icon>
        </div>

        <div class="box-label">
          Audit des modifications
        </div>
      </a>
    </div>

    <div [class.box-hidden]="isDevisValidationHidden()"  >
    <mat-divider></mat-divider>
    </div>
    

    <!-- Ligne 4 : évaluation des compétences -->
    <div class="menu-row">
      <a
        class="box"
        routerLink="/core/evaluations"
        [style.background-color]="theme.getColor('Main Dark')"
        [class.box-hidden]="isDevisValidationHidden()" 
      >
        <div class="box-icon">
          <mat-icon>assessment</mat-icon>
        </div>

        <div class="box-label">
          Évaluation des compétences
        </div>
      </a>
    </div>

  </mat-list>
</div>